/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

export const Accordion = ({
    content = "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions.",
    title = 'Accordion Item #1',
    stateProp,
    className,
    icon = '/img/icon.svg',
    img = '/img/icon-1.svg',
    onClick = () => {
        /* noop */
    },
}) => {
    return (
        <div
            className={`accordion ${stateProp} ${className}`}
            onClick={() => {
                onClick();
            }}
        >
            <div
                className="accordion-header"
                onClick={() => {
                    onClick();
                }}
            >
                <div className="accordion-title">{title}</div>
                <img
                    className="accordion-icon"
                    alt="Icon"
                    src={stateProp === 'collapsed' ? img : icon}
                />
            </div>

            <div className="accordion-content">
                <div className="accordion-text">
                    {stateProp === 'expanded' ? (
                        <p className="text-wrapper-17">{content}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

Accordion.propTypes = {
    content: PropTypes.string,
    title: PropTypes.string,
    stateProp: PropTypes.oneOf(['expanded', 'collapsed']),
    icon: PropTypes.string,
    img: PropTypes.string,
};
